var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-row",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
    },
    [
      _c(
        "el-col",
        {
          staticClass: "left_text_align padding_5px_top padding_10px_bottom",
          attrs: { span: 24 },
        },
        [
          _c(
            "el-tabs",
            {
              attrs: { id: "riskTab" },
              model: {
                value: _vm.activeName,
                callback: function ($$v) {
                  _vm.activeName = $$v
                },
                expression: "activeName",
              },
            },
            [
              _c(
                "el-tab-pane",
                { attrs: { label: "基金风险等级分布", name: "first" } },
                [
                  _c(
                    "el-row",
                    [
                      _c("el-col", {
                        staticClass: "width-950-important height-350",
                        attrs: { span: 24, id: "latestRisk" },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    {
                      staticClass: "width-950-important",
                      staticStyle: { "margin-top": "5px" },
                    },
                    [
                      _c(
                        "el-col",
                        {
                          staticClass: "fund_total_number",
                          attrs: { span: 13 },
                        },
                        [
                          _vm._v(
                            "合计：" + _vm._s(_vm.fundTotalNumber) + "只基金"
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        {
                          staticClass: "risk_date right_text_align",
                          attrs: { span: 11 },
                        },
                        [_vm._v("截止日期：" + _vm._s(_vm.latestRiskDate))]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    { staticClass: "width-950-important" },
                    [
                      _c(
                        "el-col",
                        {
                          staticClass: "fund_total_number",
                          attrs: { span: 13 },
                        },
                        [_vm._v("注：不包含已经清算的基金。")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-tab-pane",
                { attrs: { label: "基金风险画像", name: "second" } },
                [
                  _c(
                    "el-row",
                    [
                      _c("el-col", {
                        staticClass: "width-950-important height-350",
                        attrs: { span: 24, id: "marketRiskPortrait" },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    {
                      staticClass: "width-950-important",
                      staticStyle: { "margin-top": "5px" },
                    },
                    [
                      _c(
                        "el-col",
                        {
                          staticClass: "fund_total_number",
                          attrs: { span: 13 },
                        },
                        [_vm._v("注：最大回撤期间为5年")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        {
                          staticClass: "risk_date right_text_align",
                          attrs: { span: 11 },
                        },
                        [
                          _vm._v(
                            "截止日期：" + _vm._s(_vm.marketRiskPortraitDate)
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-tab-pane",
                { attrs: { label: "风险等级变动占比(一年)", name: "third" } },
                [
                  _c(
                    "el-row",
                    [
                      _c("el-col", {
                        staticClass: "width-950-important height-350",
                        attrs: { span: 24, id: "riskAdjustmentChart" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-tab-pane",
                {
                  attrs: { label: "当月风险等级变动原因分布", name: "fourth" },
                },
                [
                  _c(
                    "el-row",
                    { staticStyle: { "margin-top": "-10px" } },
                    [
                      _c(
                        "el-col",
                        {
                          staticClass: "width-950-important",
                          attrs: { span: 24 },
                        },
                        [
                          _c(
                            "el-table",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                data: _vm.tableData,
                                "default-sort": {
                                  prop: "riskIncreasing",
                                  order: "descending",
                                },
                              },
                            },
                            [
                              _c("el-table-column", {
                                attrs: {
                                  fixed: "",
                                  type: "index",
                                  label: "序号",
                                  width: "50",
                                },
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  fixed: "",
                                  prop: "adjustmentType",
                                  label: "变动原因",
                                  width: "400",
                                },
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  fixed: "",
                                  prop: "riskIncreasing",
                                  label: "风险上升",
                                  width: "250",
                                },
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "riskDecreasing",
                                  label: "风险下降",
                                  width: "250",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-row",
                            { attrs: { gutter: 50 } },
                            [
                              _c(
                                "el-col",
                                {
                                  staticClass: "risk_adjustment_item",
                                  attrs: { span: 11 },
                                },
                                [_vm._v("当期全市场基金数量：")]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-col",
                                {
                                  staticClass: "risk_adjustment_data",
                                  attrs: { span: 5 },
                                },
                                [_vm._v(_vm._s(_vm.tableFundSize))]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-row",
                            { attrs: { gutter: 50 } },
                            [
                              _c(
                                "el-col",
                                {
                                  staticClass: "risk_adjustment_item",
                                  attrs: { span: 11 },
                                },
                                [_vm._v("当期风险等级变动数量：")]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-col",
                                {
                                  staticClass: "risk_adjustment_data",
                                  attrs: { span: 5 },
                                },
                                [_vm._v(_vm._s(_vm.adjustmentSize))]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-row",
                            { attrs: { gutter: 50 } },
                            [
                              _c(
                                "el-col",
                                {
                                  staticClass: "risk_adjustment_item",
                                  attrs: { span: 11 },
                                },
                                [_vm._v("变动比例：")]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-col",
                                {
                                  staticClass: "risk_adjustment_data",
                                  attrs: { span: 5 },
                                },
                                [_vm._v(_vm._s(_vm.adjustmentRate) + "%")]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-row",
                            { staticStyle: { "margin-top": "10px" } },
                            [
                              _c(
                                "el-col",
                                {
                                  staticClass: "risk_date",
                                  attrs: { span: 11 },
                                },
                                [
                                  _vm._v(
                                    "截止日期：" +
                                      _vm._s(_vm.RiskAdjustmentTableDate)
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }